import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Alert, Button, Row, Col } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector, SubmissionError } from 'redux-form';
import Input from '../components/Input';
import * as authActionCreators from '../redux/actions/auth';
import auth from '../redux/reducers/auth';
import logo from '../images/Giftr-Seller-Center-Logo.svg';

const validate = values => {
  const errors = {}
  if (!values.email) {
    errors.email = 'Required';
  }
  if (!values.password) {
    errors.password = 'Required';
  }
  return errors
}

class Login extends Component {
  submit = (values) => {
    const { email, password, verification } = values;
    const { history: { push }, login } = this.props;
    return new Promise((resolve, reject) => {
      login(email, password, verification, push).then(() => {
        return resolve();
      });
    });
  }

  componentDidMount() {
    if (performance.navigation.type === 1) {
      const { resetLogin } = this.props;
      resetLogin();
    }
  }

  render() {
    const { handleSubmit, submitting, globalError, auth: {verify} } = this.props

    return (
      <div>
        <Row className="flex-column-reverse flex-lg-row w-100 ms-0 mt-5" id="pwd-container">
          <Col xs={12} lg={12} className="text-center">
            <form className="login-form desktop-login d-grid gap-3 mx-auto shadow-sm" style={{maxWidth: '400px'}} onSubmit={handleSubmit(this.submit)}>
              <img src={logo} style={{width: '200px'}} alt="Giftr Seller Center Logo"/>
              {/* <h4 className="mt-3 mb-5" style={{  color:'#000'}}>Login to Axis Rewards Voucher Portal</h4> */}
              {
                globalError &&
                <Alert variant="danger">
                  <div>{globalError}</div>
                </Alert>
              }
              {
                !verify &&
                <Field className="form-control" name="email" label="Email" placeholder="Email" type="email" isRenderLabel={false} component={Input} />  
              }
              {
                !verify &&
                <Field className="form-control" name="password" label="Password" placeholder="Password" type="password" isRenderLabel={false} component={Input} />
              }
              {
                verify &&
                <>
                  <Field className="form-control" name="verification" label="6-Digit Verification Code" placeholder="Verification Code" isRenderLabel={false} type="number" component={Input} />
                  <small>A 6 digit verification code has been sent to your email</small>
                </>
              }
              {
                !verify &&
                <div style={{textAlign:'right'}}>
                  <a href="./forgot_password" target="_blank" style={{textDecoration: 'none', color: '#80d7cf', fontSize: '0.9em'}}>Forgot password?</a>
                </div>
              }
              <Button
                type="submit"
                disabled={submitting}
                className="mt-5"
              >
                {submitting ? 'LOGGING IN...' : 'LOG IN'}
              </Button>
            </form>
            </Col>
        </Row>
      </div>
    );
  }
}

Login = reduxForm({
  form: 'login',
  validate,
  destroyOnUnmount: true,
  // forceUnregisterOnUnmount: true,
  // asyncValidate,
  // asyncBlurFields: ['postCode']
})(Login);

export default connect(state => {
  return {
    auth: state.auth,
    globalError: state.error,
  }
}, authActionCreators)(Login);
